const resources = {
    canadaCheckoutText: 'Passer à la caisse au Canada',
    unitedStatesCheckoutText: 'Passer à la caisse aux États-Unis'
};

export default function getResource(label) {
    return resources[label];
}
